module.exports = new __parcel__URL__("apply_k_faq_closed_btn_ja.b6e53d5b.webp").toString();